export const INSIGHT_METRICS: TopHap.InsightMetric[] = ['list_price', 'list_price_per_sqft']
export const INSIGHT_DESCRIPTIONS = [
  [
    [
      'Lowest List Price',
      'Highest List Price',
      'Low List Price',
      'High List Price'
    ],
    ['Less expensive', 'More expensive']
  ],
  [
    [
      'Lowest List $/ft²',
      'Highest List $/ft²',
      'Low List $/ft²',
      'High List $/ft²'
    ],
    ['Lower price per sqft', 'Higher price per sqft']
  ]
]
export const INSIGHT_TOLERANCE = 20
export const INSIGHT_OTHER_LABELS = ['', 'active listings']
